import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';
import myVue from './main'
import qs from 'qs';

Vue.use(Vuex)

export const adressList = [
  '地点不限',
  '市直',
  '吴兴区',
  '南浔区',
  '南太湖新区',
  '德清县',
  '长兴县',
  '安吉县'
]

export const degreeList = [
  '不限',
  // '高中',
  '大专',
  '本科',
  '硕士',
  '博士'
]

export const salaryList = [
  '薪资不限',
  '1500-1999',
  '2000-2999',
  '3000-4499',
  '4500-5999',
  '6000-7999',
  '8000-9999',
  '10000-14999',
  '15000-19999',
  '25000-29999',
  '40000-49999',
  '50000-69999',
  '15000及以上',
  '100000及以上',
]

//export const funcList = 


export const funcList=[]

export default new Vuex.Store({
  state: {
    projectId: 215,
    selector: {
      home: {
        area: '',
        func: -1,
        adress: -1,
        degree: -1,
        salary: -1,
        keyword: '',
        // order:'idasc'
        order:''
      },
      school: {
        area: '',
        func: -1,
        adress: -1,
        degree: -1,
        salary: -1,
        keyword: '',
        nokeyword:'社招',
        order:'idasc'
      },
      social: {
        area: '',
        func: -1,
        adress: -1,
        degree: -1,
        salary: -1,
        keyword: '社招',
        nokeyword:'',
        order:'idasc'
      },
      groundC: {
        area: '003',
        func: -1,
        adress: -1,
        degree: -1,
        salary: -1,
      },
      groundD: {
        area: '004',
        func: -1,
        adress: -1,
        degree: -1,
        salary: -1,
      },
    },
    jobList: {
      home: {
        list: [],
        page: 1
      },
      school: {
        list: [],
        page: 1
      },
      social: {
        list: [],
        page: 1
      },
      groundC: {
        list: [],
        page: 1
      },
      groundD: {
        list: [],
        page: 1
      },
      keyword: {
        list: [], // 关键字搜索列表一次全部给到
      }
    },
    funcList: ['职能不限'],
    login: false,
    // 展示登录框
    loginShow: false,
  },
  getters: {
    // 选项列表
    adressList() {
      return adressList
    },
    degreeList() {
      return degreeList
    },
    salaryList() {
      return salaryList
    },
    funcList: state => {
      return state.funcList
    }
  },
  mutations: {
    // 筛选器选中
    commitSelect (state, {place, option, value}) {
      console.log(place, option, value)
      state.selector[place][option] = value
    },
    // 筛选器取消
    cancelSelect (state, {place, option}) {
      state.selector[place][option] = -1
    },
    
    // 筛选器请求数据
    jobListGetBySelector(state, {place}) {
      // 抛出开始加载事件
      myVue && myVue.$eventBus.emit('startLoading')

      // 发送ajax 请求数据
      let selector = state.selector[place];
      //console.log(state.funcList[selector.func])
      axios.get('/getjob?project_id='+ state.projectId + 
        (selector.area ? `&area=${selector.area}` : '') +
        (selector.func >= 1 ? `&funtype=${state.funcList[selector.func]}` : '') +
        (selector.adress >= 1 ? `&divname=${state.adressList[selector.adress]}` : '') +
        (selector.degree >= 1 ? `&degreefrom=${degreeList[selector.degree]}` : '') +
        (selector.salary >= 1 ? `&providesalarname=${salaryList[selector.salary]}` : '') + 
        `&keyword=${selector.keyword}`+`&nokeyword=${selector.nokeyword}`+
        `&order=${selector.order}`
      ).then(res => {
        // console.log(res.data)
        if(res.data.code === 1) {
          // 尾插数据
          state.jobList[place].list = res.data.data.list
          state.jobList[place].page = 1
          // 抛出加载成功事件
          myVue.$eventBus.emit(state.jobList[place].list.length > 0 ? 'loadSuccess' : 'loadNoMore')
          myVue.$eventBus.emit('jobRefresh')
        } else {
          console.log('数据获取失败：', res.data.msg)
        }
      })
    },
    
    // 更新列表并发送数据刷新通知
    jobListNextPage(state, {place}) {
      // 抛出开始加载事件
      myVue.$eventBus.emit('startLoading')

      // 发送ajax 请求数据
      let selector = state.selector[place];
      axios.get('/getjob?project_id='+ state.projectId + 
      (selector.area ? `area=${selector.area}` : '') +
      (selector.func >= 1 ? `&funtype=${state.funcList[selector.func]}` : '') +
      (selector.adress >= 1 ? `&divname=${adressList[selector.adress]}` : '') +
      (selector.degree >= 1 ? `&degreefrom=${degreeList[selector.degree]}` : '') +
      (selector.salary >= 1 ? `&providesalarname=${salaryList[selector.salary]}` : '') +
      `&keyword=${selector.keyword}` +
      '&pageindex=' + (state.jobList[place].page + 1)
      ).then(res => {
         //console.log(res.data)
        if(res.data.code === 1) {
          if(res.data.data.list.length > 0) {
            // 尾插数据
            state.jobList[place].list = state.jobList[place].list.concat(res.data.data.list)
            state.jobList[place].page += 1
            // 抛出加载成功事件
            myVue.$eventBus.emit('loadSuccess') 
          } else {
            // 抛出无加载事件
            myVue.$eventBus.emit('loadNoMore')
          }
          // console.log(state.jobList[place].list)
        } else {
          console.log('数据获取失败：', res.data.msg)
          myVue.$eventBus.emit('loadNoMore')
        }
      })
    },

    // 从后台获取职能列表
    funcTypeInit(state) {
      axios.get('/getFuntype?project_id=' + state.projectId).then(({data: res})=>{
      // console.log(res)
        const {code, data: list} = res;
        code === 1 && list.length > 0 && state.funcList.length <= 1 && (state.funcList = state.funcList.concat(list));
        // console.log(state.funcList)
      }).catch(err => {
        console.log(err)
      })
    },

    // 关键字请求数据
    jobListGetByKeyword(state, {keyword}) {
      // 抛出开始加载事件
      myVue.$eventBus.emit('startLoading')

      axios.get('/getjob?project_id='+state.projectId+'&keyword=' + keyword +'&order=suedatedesc').then(res => {
        if(res.data.code === 1) {
          // 保存搜索数据列表
          state.jobList.keyword.list = res.data.data.list
          myVue.$eventBus.emit(state.jobList.keyword.list.length > 0 ? 'loadSuccess' : 'loadNoMore')
        } else {
          console.log('数据获取失败：', res.data.msg)
        }
      })
    },

    // 检查是否登录：
    loginShow(state) {
      state.loginShow = true;
    },

    // 登录：
    login(state, {sid, pwd}){
      axios.post('/jdLogin?project_id=' + state.projectId, qs.stringify({
        sid: sid,
        pwd: pwd
      })).then( res => {
        if(res.data.code === 1) {
          state.login = true
          state.loginShow = false
          alert('登录成功')
        }
      }).catch( err => {
        alert('登录失败')
      })
    },

    // 取消登录：
    loginCancel(state) {
      state.loginShow = false;
    }
  },
  actions: {
    // 检查登录
    checkLoged ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if(!state.login) {
          commit('loginShow')
        } else {
          resolve(state.login)
        }
      })
    }
  }
})